import { jsx as _jsx } from "react/jsx-runtime";
import { useSetItemsStarred } from "@sprout/client-graphql";
import { useCallback } from "react";
import { PriorityHighOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import PostPageHeaderCancellableButton from "./PostPageHeaderCancellableButton";
const PostPageHeaderStarredButton = (props)=>{
    const { item  } = props;
    const setItemStarred = useSetItemsStarred();
    const removeStarred = useCallback(()=>{
        setItemStarred({
            items: [
                item
            ],
            starred: false
        });
    }, [
        item,
        setItemStarred
    ]);
    return /*#__PURE__*/ _jsx(PostPageHeaderCancellableButton, {
        onClick: removeStarred,
        to: "/priorities",
        icon: /*#__PURE__*/ _jsx(Flex, {
            color: "#38b7bf",
            as: PriorityHighOutlined
        }),
        label: "Priority"
    });
};
export default PostPageHeaderStarredButton;
